/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// UI lib components
import { Badge, Text, Tooltip } from '@mantine/core';

// UI local components
import ResourceIcon from '@features/Resource/ResourceIcon';

// Types
import { ResourceBadgeProps } from './types';

// Style
import * as classes from './styles/index.css';
import * as badgeStylesAPI from './styles/badgeStylesAPI.css';
import { memo } from 'react';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function ResourceBadge({
  resource,
  withoutTooltip = true,
  truncable = false,
  iconSize,
  fontSize = 12,
  hideLabel,
  cursor = 'default',
  ...props
}: ResourceBadgeProps) {
  /* ********************************** HOOKS ********************************* */

  // Style

  /* ***************************** LOCAL VARIABLES **************************** */

  const icon = (
    <ResourceIcon
      className={classes.icon}
      resource={resource}
      withColor
      size={iconSize}
    />
  );

  /* ******************************** RENDERING ******************************* */

  return (
    <Tooltip
      label={resource.name}
      position="top"
      fz="xs"
      withinPortal
      zIndex={400}
      display={withoutTooltip ? 'none' : undefined}
    >
      <Badge
        classNames={{ ...badgeStylesAPI }}
        size="xs"
        h="auto"
        tt="inherit"
        px={0}
        radius={0}
        leftSection={icon}
        fullWidth
        {...props}
      >
        {hideLabel ? null : (
          <Text
            fz={fontSize}
            c="blackroomBlack"
            style={{ cursor }}
            maw={truncable ? '95%' : undefined}
            truncate={truncable ? true : undefined}
            ta="left"
          >
            {resource.name}
          </Text>
        )}
      </Badge>
    </Tooltip>
  );
}

export default memo(ResourceBadge);
